export const formDispositionCodes = [
  {
    code: 'W',
    name: 'To Warehouse',
  },
  {
    code: 'T',
    name: 'Transfer (to other BU)',
  },
  {
    code: 'S',
    name: 'Scrap',
  },
  {
    code: 'P',
    name: 'Parts',
  },
  {
    code: 'L',
    name: 'Landfill',
  },
  {
    code: 'M',
    name: 'Missing',
  },
  {
    code: 'R',
    name: 'Recycle'
  },
  {
    code: '?',
    name: 'Invalid Code '
  }
];

export const eoneDispositionCodes = [
  { code: 'AV', name: 'Available - On Job Site' },
  { code: 'DM', name: 'Demobilization' },
  { code: 'DN', name: 'Down - On Site' },
  { code: 'DS', name: 'Down - In Shop' },
  { code: 'MB', name: 'Mobilization' },
  { code: 'SB', name: 'Standby' },
  { code: 'WK', name: 'Working' },
  { code: '1C', name: 'Disposed - Charity' },
  { code: '1D', name: 'Disposed - Destroyed' },
  { code: '1O', name: 'Disposed - Outright Sale' },
  { code: '1R', name: 'Disposed - Returned to Vendor' },
  { code: '1S', name: 'Disposed - Scrapped' },
  { code: '1T', name: 'Disposed - Sale w/ Trade In' },
  { code: '1X', name: 'Disposed - Theft' },
  { code: '9A', name: 'Disposed - Auction' },
  { code: '9B', name: 'Disposed - Board of Education' },
  { code: '9G', name: 'Disposed - Other Government' },
  { code: '92', name: 'Unaccountable Item (MISSING)' },
  { code: '93', name: 'Non Recordable/Removed Items' },
  { code: '94', name: 'Duplicate Item' },
  { code: '95', name: 'Entered in OneWorld In Error' },
  { code: '96', name: 'Inventory-Hold' },
  { code: '97', name: 'Surplus Property-Computers' },
  { code: '98', name: 'Surplus Property-Other' },
  { code: '99', name: 'Dispose Inventory Asset' }
];

export const allDispCodes = [...formDispositionCodes, ...eoneDispositionCodes]
